import { Box, Stack, IconButton } from '@mui/material';
import { common } from '@mui/material/colors';
// import BaseInputNumber from 'common/components/base-input-number';
import BaseNumberField from 'common/components/base-number-field';
import BaseTextField from 'common/components/base-text-field';
import RequiredLabel from 'common/components/required-label';
import { styleInput, styleInputNumber } from 'common/constants';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { createStyleSheet } from 'utils/helpers';
import { IQuestionAnswer, IQuestionBaseProps } from 'types/campaign-design';
import QuestionDnD from './question-dnd';
import MinusIcon from '@mui/icons-material/Remove';
import PlusIcon from '@mui/icons-material/Add';

const QuestionTextRecommend: React.FC<IQuestionBaseProps> = ({
    question,
    ...props
}) => {
    const { watch, control, setValue } = useFormContext();
    const { insert, remove } = useFieldArray({
        control,
        name: `data.answers`,
    });

    const numberOfRows = watch(`data.numberOfRows`);
    const answers = watch('data.answers');

    const removeAnswer = (fieldIndex: number) => {
        remove(fieldIndex);
        setValue('data.numberOfRows', numberOfRows ? numberOfRows - 1 : 0);
    };

    const insertAnswer = (fieldIndex: number) => {
        insert(fieldIndex + 1, {
            id: null,
            answer: `Tuỳ chọn ${numberOfRows + 1}`,
        });
        setValue('data.numberOfRows', numberOfRows + 1);
    };

    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={3}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                    <QuestionDnD {...props} />
                    {!question.answerFromOtherQuestionLogic?.id &&
                        answers?.length === 0 && (
                            <Box
                                display={'flex'}
                                alignItems={'center'}
                                width={'100%'}
                            >
                                <IconButton onClick={() => insertAnswer(0)}>
                                    <PlusIcon />
                                </IconButton>
                                <Box component={'span'}>Thêm đáp án</Box>
                            </Box>
                        )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            width: '100%',
                        }}
                    >
                        {answers?.map(
                            (item: IQuestionAnswer, fieldIndex: number) => {
                                const answerValue = watch(
                                    `data.answers.${fieldIndex}.answer`
                                );
                                return (
                                    <Box
                                        key={item.id}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                        }}
                                    >
                                        <BaseTextField
                                            autoComplete="off"
                                            fullWidth
                                            name={`data.answers.${fieldIndex}.answer`}
                                            value={answerValue}
                                            size="small"
                                            placeholder="Nhập tùy chọn câu trả lời"
                                            sx={styles.answer}
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 255,
                                                },
                                            }}
                                        />
                                        <Box
                                            display={'flex'}
                                            marginLeft={'15px'}
                                        >
                                            {answers?.length > 1 && (
                                                <IconButton
                                                    onClick={() =>
                                                        removeAnswer(fieldIndex)
                                                    }
                                                >
                                                    <MinusIcon />
                                                </IconButton>
                                            )}
                                            <IconButton
                                                onClick={() =>
                                                    insertAnswer(fieldIndex)
                                                }
                                            >
                                                <PlusIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                </Box>
            </Stack>
            <Stack
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={4}
                p={'35px'}
                sx={{
                    borderTop: `2px dashed var(--color-primary)`,
                }}
                display={'none'}
            >
                <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Số hàng"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseNumberField
                        sx={styleInputNumber}
                        size="small"
                        name={`data.numberOfRows`}
                        min={1}
                        InputProps={{
                            readOnly: true,
                        }}
                        forceDisableMinus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        forceDisablePlus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        disabled={!!question.answerFromOtherQuestionLogic?.id}
                        showMinus={false}
                        showPlus={false}
                    />
                </Stack>
                {/* <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Giới hạn ký tự nhập"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseInputNumber
                        sx={styles.limitSize}
                        size="small"
                        name={`data.limitCharacter`}
                    />
                </Stack> */}
            </Stack>
        </Box>
    );
};

const styles = createStyleSheet({
    answer: {
        '& .MuiInputBase-root': {
            ...styleInput['& .MuiInputBase-root'],
            height: '65px',
            borderRadius: '50px',
        },
    },
    limitSize: {
        '& .MuiInputBase-root': {
            height: '24px',
            background: common.white,
            maxWidth: '247px',
            fieldset: {
                border: `1px solid ${common.black}`,
            },
        },
    },
});
export default QuestionTextRecommend;
